/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveMdmMatchingPolicyRequest
 */
export interface SaveMdmMatchingPolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    configurationId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    policyId?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    policyVersionLabel?: string;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    rules?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    guards?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    thresholds?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    pipeline?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof SaveMdmMatchingPolicyRequest
     */
    acknowledgedProspectiveOnly?: boolean;
}

/**
 * Check if a given object implements the SaveMdmMatchingPolicyRequest interface.
 */
export function instanceOfSaveMdmMatchingPolicyRequest(value: object): value is SaveMdmMatchingPolicyRequest {
    return true;
}

export function SaveMdmMatchingPolicyRequestFromJSON(json: any): SaveMdmMatchingPolicyRequest {
    return SaveMdmMatchingPolicyRequestFromJSONTyped(json, false);
}

export function SaveMdmMatchingPolicyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveMdmMatchingPolicyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'configurationId': json['configurationId'] == null ? undefined : json['configurationId'],
        'policyId': json['policyId'] == null ? undefined : json['policyId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'policyVersionLabel': json['policyVersionLabel'] == null ? undefined : json['policyVersionLabel'],
        'rules': json['rules'] == null ? undefined : json['rules'],
        'guards': json['guards'] == null ? undefined : json['guards'],
        'thresholds': json['thresholds'] == null ? undefined : json['thresholds'],
        'pipeline': json['pipeline'] == null ? undefined : json['pipeline'],
        'acknowledgedProspectiveOnly': json['acknowledgedProspectiveOnly'] == null ? undefined : json['acknowledgedProspectiveOnly'],
    };
}

export function SaveMdmMatchingPolicyRequestToJSON(json: any): SaveMdmMatchingPolicyRequest {
    return SaveMdmMatchingPolicyRequestToJSONTyped(json, false);
}

export function SaveMdmMatchingPolicyRequestToJSONTyped(value?: SaveMdmMatchingPolicyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configurationId': value['configurationId'],
        'policyId': value['policyId'],
        'assetClass': value['assetClass'],
        'displayName': value['displayName'],
        'policyVersionLabel': value['policyVersionLabel'],
        'rules': value['rules'],
        'guards': value['guards'],
        'thresholds': value['thresholds'],
        'pipeline': value['pipeline'],
        'acknowledgedProspectiveOnly': value['acknowledgedProspectiveOnly'],
    };
}

